// Inline images that arrive embedded in a message's HTML body (e.g. a pasted
// screenshot in an inbound email) reach the client as `<img src="/api/attachments/{id}?dl={token}">`.
// The ticketing backend already rewrote the original `cid:` reference to that
// signed, relative path. But served from the Forecast origin that path hits the
// SPA fallback (returning index.html), so the image renders broken — the same
// origin drift that `attachmentProxyPath` fixes for attachment download links.
//
// This rewrites each such inline <img> src through `toAbsoluteUrl` (the same
// `ticketingAttachmentDownloadUrl` transform used for attachment links), so the
// browser loads it from the Forecast graphql same-origin proxy. Non-attachment
// srcs (https/http/data) are left untouched.

const ATTACHMENTS_PREFIX = '/api/attachments/';

export function rewriteInlineImageSrcs(html: string, toAbsoluteUrl: (src: string) => string): string {
	if (!html) return html;

	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');
	const imgElements = doc.querySelectorAll('img');

	let rewroteAny = false;
	imgElements.forEach(img => {
		const src = img.getAttribute('src');
		if (src == null || !src.startsWith(ATTACHMENTS_PREFIX)) return;
		img.setAttribute('src', toAbsoluteUrl(src));
		rewroteAny = true;
	});

	if (!rewroteAny) return html;

	const serializer = new XMLSerializer();
	const body = doc.body;
	return body ? serializer.serializeToString(body).replace(/^<body[^>]*>|<\/body>$/gi, '') : html;
}
